<template>
	<div class="logPage">
		<el-dialog
			title="日志"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="40%"
			custom-class="tabDialog"
			:before-close="handleClose"
		>
			<div class="height">
				<data-list
					:page="page"
					:table-style="{ name: 'webclient' }"
					:data="data"
					:columns="logcolumns"
					@page-size-changed="pageSizeChanged"
					@page-changed="pageChanged"
					@sort-change="sortChange"
				></data-list>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
const list = listPageCreate({
	searchConfig: {
		api: api.adsNewOnline.logpage,
		method: 'POST',
	},
	getQuery(obj, that) {
		return _.assign(obj, { automationId: that.automationId });
	},
});
export default {
	props: ['dialogVisible', 'automationId'],
	mixins: [list],
	data() {
		return {
			logdata: [],
			logcolumns: [
				{ label: '操作人', bind: 'accountName' },
				{ label: '操作时间', bind: 'createTime' },
			],
		};
	},

	components: {},
	watch: {
		automationId: {
			handler(val) {
				if (val) {
					this.query();
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		handleClose() {
			this.$emit('handleClose');
			this.$emit('update:dialogVisible', false);
		},
	},
};
</script>

<style lang="scss" scoped>
.logPage {
	::v-deep .tabDialog {
		padding: 0px;
	}
	.height {
		min-height: 200px;
		overflow: hidden;
	}
	/*滚动条样式*/
	.height::-webkit-scrollbar {
		position: relative;
		width: 6px;
	}
	.height::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
		background: rgba(163, 155, 155, 0.2);
	}
	.height::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
		border-radius: 0;
		background: rgba(193, 185, 185, 0.1);
	}
}
</style>
